// src/TrackPageViews.jsx
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { fbq } from "./fbq";

export default function TrackPageViews() {
  const { pathname, search } = useLocation();
  const didMountRef = useRef(false);

  useEffect(() => {
    if (!didMountRef.current) {
      
      didMountRef.current = true;
      return;
    }
    fbq("track", "PageView");
  }, [pathname, search]);

  return null;
}
